var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaintBucket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_4152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.39216 2.33898L11.0721 7.63972M2.7151 13.1315L17.6862 14.0627M19.8065 12.1907L12.3185 3.70951L3.20124 11.7591C2.81228 12.1095 2.57622 12.5984 2.54372 13.1209C2.51122 13.6434 2.68489 14.1578 3.02742 14.5537L7.8946 20.0664C8.64339 20.9146 9.84108 20.989 10.6892 20.2402L19.8065 12.1907ZM22.242 21.3596C22.2091 21.889 21.9672 22.3836 21.5695 22.7347C21.1719 23.0858 20.6511 23.2645 20.1217 23.2316C19.5923 23.1986 19.0976 22.9567 18.7466 22.5591C18.3955 22.1615 18.2168 21.6407 18.2497 21.1113C18.349 19.5143 20.0954 18.8214 20.4942 17.2431C20.6943 18.8587 22.3413 19.7627 22.242 21.3596Z",
    stroke: "#787777",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_4152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(1.52344 0.0322266) rotate(3.55901)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintBucket);
export default __webpack_public_path__ + "static/media/paint-bucket.f499399257069adced852d14af2597ed.svg";
export { ForwardRef as ReactComponent };